import { useState } from "react";

import "./Projects.css";

import {
  fabib,
  crypto,
  portfolio,
  anime,
  btstrap,
  react,
  js,
  node,
  express,
  mongodb,
  alqand,
  next,
  tailwind
} from "../indexPics";

const projects = [
  {
    title: "Al-quand for exchange",
    img: alqand,
    description:
      "This web site for Al-qand company is an SPA (Single Page Application) that allows users to reserve and register for exchange services. The website is built using Next.js, Taiwind CSS",
    technologies: [next, tailwind],
    url: "https://alqandforexchange.com/",
  },
  {
    title: "Fabib",
    img: fabib,
    description:
      "I'm currently working on a social media app, similar to Facebook. It's a project where I apply my knowledge of both front-end and back-end development. For the front-end, I'm using vanilla JavaScript, while on the back-end, I'm using Express with EJS templates.",
    technologies: [btstrap, js, node, express, mongodb],
    url: "",
  },
  {
    title: "Portfolio",
    img: portfolio,
    description:
      "I've developed a modern portfolio website for a mathematics teacher. The design is clean and professional, showcasing their teaching experience, qualifications, and achievements.",
    technologies: [react, btstrap],
    url: "https://youcefmaouch-81857.web.app/",
  },
  {
    title: "Crypto Club",
    img: crypto,
    description:
      "I created the official website for Crypto club, featuring a modern design and providing information about the club's activities, events and more",
    technologies: [js, btstrap],
    url: "https://cryptoclubusthb.github.io/website.io/",
  },
  {
    title: "Shahid 17",
    img: anime,
    description:
      "This is my first website, it was about anime, where I used Node.js to scrape video URLs from an anime site and display them on my own. The best feature is that users don’t need to refresh the page for new episodes—the iframe tag automatically loads the current episode's URL.",
    technologies: [react, btstrap, js],
    url: "https://habib17-bc194.web.app/",
  },
];

function Projects() {
  const [selectedproject, setselectedproject] = useState(projects[0]);
  const [isAnimating, setIsAnimation] = useState(false);

  const handelClick = (project) => {
    if (selectedproject !== project) setIsAnimation(true);
    setTimeout(() => {
      setselectedproject(project);
      setIsAnimation(false);
    }, 200);
  };

  return (
    <>
      <h1> PROJECTS </h1>
      <div className="container d-flex flex-row flex-wrap">
        <div className="projects col-md-6 col-sm-12 ">
          {projects.map((project) => {
            return (
              <div className="project" onClick={() => handelClick(project)}>
                <img
                  className={selectedproject === project ? "selected" : ""}
                  src={project.img}
                />
                <h2> {project.title} </h2>
              </div>
            );
          })}
        </div>

        <div
          className={`col-sm-12 col-md-6  selected-project ${
            isAnimating ? "fade-out" : "fade-in"
          }`}
        >
          <div className="d-flex justify-content-center align-items-center flex-column">
            <h2>{selectedproject.title}</h2>
            <img className="selected-project-img" src={selectedproject.img} />
          </div>
          <h3 className="mt-4">Description :</h3>
          <p>{selectedproject.description}</p>
          <h3>Technologies used :</h3>
          <div className="technologies mb-4">
            {selectedproject.technologies.map((tech) => {
              return (
                <div>
                  {" "}
                  <img src={tech} />
                </div>
              );
            })}
          </div>
          {selectedproject.url ? (
            <div className="d-flex justify-content-center">
              {" "}
              <a target="_blank" href={selectedproject.url}>
                <button className="btn btn-primary">Demo</button>
              </a>{" "}
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
}
export default Projects;
